<template>
  <AppHeader>Create Subscription</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Customer</p>
        <CustomerSearch v-model="form.customer_id" :customers="customers" autofocus></CustomerSearch>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.customer_id">{{ errors.customer_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Product</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.product_id" name="product_id">
          <option value="">-- Select Product --</option>
          <option v-for="product in products" :key="product.id" :value="product.id">{{ product.name }} ({{ product.quantity }})</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.product_id">{{ errors.product_id }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Repeat</p>
        <select class="w-full text-xl bg-white placeholder:text-lg" v-model="form.type" name="type">
          <option value="single">Once</option>
          <option value="everyday">Everyday</option>
          <option value="alternatedays">Alternate Days</option>
        </select>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.type">{{ errors.type }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Quantity</p>
        <div class="flex justify-start mt-2 gap-x-2">
          <button class="px-3 py-1 text-2xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.quantity == 1}" @click="form.quantity = 1">1</button>
          <button class="px-3 py-1 text-2xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.quantity == 2}" @click="form.quantity = 2">2</button>
          <button class="px-3 py-1 text-2xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.quantity == 3}" @click="form.quantity = 3">3</button>
          <button class="px-3 py-1 text-2xl leading-none rounded bg-slate-200" :class="{'border-2 border-slate-400': form.quantity == 4}" @click="form.quantity = 4">4</button>
        </div>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.quantity">{{ errors.quantity }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Start Date</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.start_date" name="start_date" type="date" :min="tom" placeholder="Select Start Date">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.start_date">{{ errors.start_date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">End Date</p>
        <input class="w-full text-xl placeholder:text-lg" v-model="form.end_date" name="end_date" type="date" :min="form.start_date" placeholder="Select End Date">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.end_date">{{ errors.end_date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Notes</p>
        <textarea class="w-full text-xl placeholder:text-lg" v-model="form.notes" name="notes" placeholder="Enter Notes"></textarea>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.notes">{{ errors.notes }}</p>
      </div>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="createSubscription">Create Subscription</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import CustomerSearch from '@/components/common/CustomerSearch.vue';

export default {
  name: 'CreateSubscription',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading, CustomerSearch },
  data() {
    return {
      state: 'loading',
      tom: null,
      customers: [],
      products: [],
      form: { customer_id: '', product_id: '', quantity: 1, type: 'everyday' },
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'subscriptions/prepare', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.customers = resp.data.customers;
          this.products = resp.data.products;
        }
      });
    },

    createSubscription() {
      let rules = {
        customer_id: 'required|numeric',
        product_id: 'required|numeric',
        type: 'required|notempty',
        quantity: 'required|numeric',
        start_date: 'required|date',
        end_date: 'dateempty',
        notes: '',
      };

      if (!this.validateForm(this.form, rules)) return;
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';
      if (this.form.type == 'single') this.form.end_date = this.form.start_date;
      this.form.dealer_id = this.$store.state.user.id;

      this.request('POST', 'subscriptions', this.form, (resp) => {
        this.state = 'idle';
        if (resp.success) this.form = { customer_id: this.$route.query.customer_id ? this.$route.query.customer_id : '', product_id: '', quantity: 1, type: 'everyday' };
        alert(resp.message);
      });
    },
  },

  created() {
    let d = new Date();
    d.setDate(d.getDate() + 1);

    if (d.getHours() >= 19 && d.getMinutes() >= 1) d.setDate(d.getDate() + 1);

    this.tom = d.toISOString().substr(0, 10);
    this.form.start_date = d.toISOString().substr(0, 10);
    if (this.$route.query.customer_id) this.form.customer_id = this.$route.query.customer_id;
    this.getData();
  }
}
</script>
